import type {
  TreeViewDataObject,
  TreeViewItemDropdownAction,
} from "@lxc/app-device-common";
import type { ComposerTranslation } from "vue-i18n";
import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import { MAX_SECTOR_DEPTH } from "~/modules/sector/constants";
import { DropdownActions } from "~/modules/sector/models/DropdownActions.enum";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import ILxcEdit2 from "~icons/lxc/edit-2";
import ILxcFolderPlus from "~icons/lxc/folder-plus";
import ILxcTrash2 from "~icons/lxc/trash-2";

const { can } = useAcl();

export function mapSectorsToTreeViewDataObjects(
  sector: Sector,
  t: ComposerTranslation,
  currentDepth: number = 0,
): TreeViewDataObject[] {
  const dropdownActions: TreeViewItemDropdownAction[] = [];

  if (currentDepth < MAX_SECTOR_DEPTH) {
    dropdownActions.push({
      id: DropdownActions.CREATE,
      label: t("sectors.button.newSub"),
      icon: ILxcFolderPlus,
    });
  }

  if (!sector.isRootSector) {
    dropdownActions.push(
      {
        id: DropdownActions.UPDATE,
        label: t("sectors.button.update"),
        icon: ILxcEdit2,
      },
      {
        id: DropdownActions.REMOVE,
        label: t("sectors.button.remove"),
        icon: ILxcTrash2,
      },
    );
  }

  const sectorTreeViewDataObject: TreeViewDataObject = {
    id: sector.code,
    label: sector.name,
    children: [],
    showDropdownActions:
      can(ACLRoles.CAN_WRITE_SECTOR) && sector.statuses.granted,
    dropdownActions,
  };

  if (sector.children.length > 0) {
    for (const child of sector.children) {
      sectorTreeViewDataObject.children =
        sectorTreeViewDataObject.children.concat(
          mapSectorsToTreeViewDataObjects(child, t, currentDepth + 1),
        );
    }
  }

  return [sectorTreeViewDataObject];
}
